import * as React from 'react';

function SvgCreditCard(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={57} height={56} {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(.362)">
        <rect width={56} height={56} fill="#ECF7FF" rx={6} />
        <path
          fill="#3481F5"
          fillRule="nonzero"
          d="M15.01 35.933c.001.406.161.796.443 1.082.28.286.664.446 1.063.445h22.918c.832 0 1.506-.684 1.506-1.527v-9.92H15.01v9.92zm19.165-5.341h4.134l-.751 3.434h-4.134l.752-3.434zM39.435 18h-22.92c-.83 0-1.505.684-1.505 1.527v4.197h25.93v-4.197c0-.405-.16-.794-.444-1.083A1.484 1.484 0 0039.433 18h.001z"
        />
      </g>
    </svg>
  );
}

export default SvgCreditCard;
